module.exports = __webpack_public_path__ + "img/img_good.0f3f6721.png";